import React from 'react';
import { IIconProps } from './utils';

export const CoTeacher = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6666 13.3334V12.0001C12.6666 10.4961 11.6706 9.22479 10.3022 8.80974C10.1131 8.75238 9.91073 8.80475 9.75643 8.92819L8.41638 10.0002C8.1729 10.195 7.82694 10.195 7.58346 10.0002L6.24341 8.92819C6.08911 8.80475 5.88673 8.75238 5.69763 8.80974C4.32926 9.22479 3.33325 10.4961 3.33325 12.0001V13.3334C3.33325 13.7016 3.63173 14.0001 3.99992 14.0001H11.9999C12.3681 14.0001 12.6666 13.7016 12.6666 13.3334Z"
      stroke={fill}
      strokeWidth="1.33333"
    />
    <path
      d="M7.99992 2C6.52716 2 5.33325 3.19391 5.33325 4.66667C5.33325 6.13943 6.52716 7.33333 7.99992 7.33333C9.47268 7.33333 10.6666 6.13943 10.6666 4.66667C10.6666 4.18095 10.5367 3.72556 10.3098 3.33333"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="1.33333"
    />
  </svg>

);
